/*=========================================================================================
  File Name: moduleSpace.js
  Description: Space Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleStudentNoticeState.js'
import mutations from './moduleStudentNoticeMutations.js'
import actions from './moduleStudentNoticeActions.js'
import getters from './moduleStudentNoticeGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
